"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isBoolean = function isBoolean(obj) {
  return typeof obj === 'boolean';
};

var _default = isBoolean;
exports["default"] = _default;